import AbsenceService from 'src/modules/absence/absenceService';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';

const prefix = 'ABSENCE_VIEW';

const absenceViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: absenceViewActions.FIND_STARTED,
      });

      const record = await AbsenceService.find(id);

      dispatch({
        type: absenceViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: absenceViewActions.FIND_ERROR,
      });

      getHistory().push('/ausencia');
    }
  },
};

export default absenceViewActions;
